import {ExternalLinksSection} from '@/models/LobbyDataResponse.model'
import Component from 'vue-class-component'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {Action, Getter, Mutation} from 'vuex-class'
import AfterFetchComponent from '@/components/base/AfterFetchComponent'

@Component({})
export default class ImportantLinksComponent extends AfterFetchComponent {

    @Action('getLobbyData', StoreNamespace.LOBBY) getLobbyData: any
    @Mutation('setLobbyData', StoreNamespace.LOBBY) setLobbyData: any
    @Getter('externalLinksSection', StoreNamespace.LOBBY) externalLinksSection!: ExternalLinksSection

    mounted() {
        this.getLobbyData({requestorCallback: this})
    }

    onSuccess(data?: any, requestName?: any, message?: any) {
        this.setLobbyData({lobbyData: data.lobbyData, expirationDate: data.expirationDate})
    }
}